module.exports = __webpack_public_path__ + "img/rejected.6d7cde63.svg";